<div class="max-w-3xl py-12 mx-8 my-12 border border-gray-200 rounded-lg md:mx-auto">
	<div class="max-w-lg mx-auto text-center">
		<div class="p-3 mx-auto bg-red-100 rounded-lg max-w-max">
			<uc-exclamation-mark-triangular-svg />
		</div>
		<p class="px-8 pt-5 text-lg font-semibold text-gray-900">
			An unexpected error occurred
		</p>
		<p class="px-8 pt-2 text-sm text-gray-600">
			An issue on our end caused an unexpected error please refresh this page or
			return to the previous page and try again.
		</p>
		<button
			(click)="onBack()"
			class="flex items-center gap-3 px-5 py-3 mx-auto mt-8 text-sm font-bold leading-5 border-2 rounded-lg text-uc-blue-900 border-uc-blue-900 max-w-max"
		>
			<uc-arrow-left-svg />
			<span>Back to previous page</span>
		</button>
	</div>
</div>
